<template>
  <div v-if='loading'>

    <oil-cap
        :title='orderTitle.toUpperCase()'
        :buttons='buttons'
        :searchLocalFilter="searchLocal"
    />
    <v-row class='mt-10 mb-5'>
      <v-col cols='6' sm='6' md='4'>
        <oil-date-picker
            itemKey='date1'
            :item='dateSearch'
            :keys='dateKeys'
            :attr='dateKeys.attrs'
            :vInput='input'
        />
      </v-col>
      <v-col cols='6' sm='6' md='4'>
        <oil-date-picker
            itemKey='date2'
            :attr='dateKeys.attrs'
            :item='dateSearch'
            :keys='dateKeys'
            :vInput='input'
        />
      </v-col>
      <v-col cols='6' sm='6' md='4'>
        <v-btn @click='downloadFile' color='primary' v-text="'ЗАГРУЗИТЬ'"/>
      </v-col>
    </v-row>
    <oil-table
        :keys='keys'
        :items='orders'
        :hideFooter='false'
        :search="search"
        :color='color'
    >

      <template v-slot:Id='{value}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn v-bind='attrs'
                   v-on='on' icon
                   @click.stop='handleRowClick(value)'>
              <v-icon color='primary'>
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          <span>РЕДАКТИ́РОВАТЬ</span>
        </v-tooltip>
      </template>
      <template v-slot:Status='{object}'>
        <v-select
            :items='statuses'
            class='font-weight-bold'
            item-text='text'
            item-value='value'
            v-model='object.OrderStatus'
            @change='changeStatus(object.Id,object.OrderStatus)'
        />
      </template>
    </oil-table>
  </div>
</template>

<script>
import {orderService} from '@/services/OrderService'
import {table, cap} from './order.json'
import xlsx from 'json-as-xlsx'
import {coreApi} from '~/services/core'

export default {
  data: () => ({
    input: {isEdit: true},
    printe: true,
    printe1: true,
    dateKeys: {
      attrs: {
        readonly: false,
        outlined: true,
        dense: true
      }
    },
    dateSearch: {
      date1: '',
      date2: ''
    },
    statuses: [
      {
        text: 'ТТН Создан',
        value: 'inprocess'
      },
      {
        text: 'ТТН в процессе',
        value: 'active'
      },
      {
        text: 'ТТН отгружен',
        value: 'fail'
      },
      {
        text: 'ТТН возрат',
        value: 'return'
      }
    ],
    statusesWaybill: [
      {
        text: ' Шофер принял',
        value: 'inprocess'
      },
      {
        text: 'Шофер в пути',
        value: 'active'
      },
      {
        text: 'Шофер отгрузил',
        value: 'success'
      },
      {
        text: 'Шофер свободен',
        value: 'empty'
      }
    ],
    loading: false,
    orderTitle: cap.title,
    keys: table.keys,
    buttons: cap.buttons,
    statusLocal: {
      active: 'Активный',
      notsigned: 'Неподписанный',
      special: 'Особый',
      inactive: 'Неактивный'
    },
    orders: [],
    search: null
  }),
  async created() {

    const orders = await orderService.getOrders()
    this.orders = orders.data?.map(order => {
      let number
      if (order.WaybillNumber)
        number = order.ContractNumber ? `${order.ContractNumber}-${order.WaybillNumber}` : ''
      else
        number = ''
      return {
        ...order,
        VATRate: order.VATRate + ' %',
        Supplier: order?.BuyerCompanyName,
        GrossPricePerTonne: this.regular(order.GrossPricePerTonne),
        WaybillNumber: number,
        WaybillStatus: this.statusLocal[order.WaybillStatus],
        AmountInLitre: this.regular(order.AmountInLitre),
        AmountInTonne: this.regular(order.AmountInTonne),
        NetTotal: this.regular(order.NetTotal),
        TotalNoVAT: this.regular(order.TotalNoVAT),
        VAT: this.regular(order.VAT),
        Total: this.regular(order.Total),
        GrossPricePerLitre: this.regular(order.GrossPricePerLitre),
        Excise: this.regular(order.Excise),
        TotalExcise: this.regular(order.TotalExcise),
        ContactBalance: this.regular(order.ContactBalance),

      }
    })
    this.loading = true
  },
  components: {
    OilCap: () => import('@/components/helper/oil.cap'),
    OilTable: () => import('@/components/helper/oil.table'),
    OilDatePicker: () => import('@/components/helper/form/oil.date.picker')
  },
  methods: {
    async orderPaginate(page) {
      //
    },
    searchLocal(input) {
      this.search = input
    },
    color(item) {
      const itemStatus = item.OrderStatus
      if (itemStatus === 'fail') {
        return 'success-color'
      } else if (itemStatus === 'inprocess') {
        return ''
      } else if (itemStatus === 'active') {
        return 'warning-color'
      } else if (itemStatus === 'return') {
        return 'red-color'
      }
    },
    show(group, type = '') {
      const text = `
        This is notification text!
        <br>
        Date: ${new Date()}
      `
      this.$notify({
        group,
        title: `Test ${type} notification #${this.id++}`,
        text,
        type,
        data: {
          randomNumber: Math.random()
        }
      })
    },
    handleRowClick(Id) {
      this.$router.push(`order-update/${Id}`)
    },
    async searchOrders() {
      //window.open('data:application/vnd.ms-excel,' + encodeURIComponent(tab_text));
      const {date1, date2} = this.dateSearch
      const result = await orderService.getSearch(date1, date2)
      this.orders = result.data
    },
    async changeStatus(id, status) {

      const params = {
        id, status
      }
      await coreApi.get(`order/status`, {params})
    },
    async downloadFile(event) {
      const {date1, date2} = this.dateSearch
      const result = await orderService.getSearch(date1, date2)

      if (result.data?.length > 0) {

        const oderColumns = [
          {
            'label': 'ПОСТАВЩИК',
            'value': 'Supplier'
          },
          {
            'label': 'ДОГОВОР',
            'value': 'ContractNumber'
          },
          {
            'label': 'ДИЛЕР',
            'value': 'Dealer'
          },
          {
            'label': 'ТОВАР',
            'value': 'ProductName'
          },
          {
            'label': 'ТТН НОМЕР',
            'value': 'WaybillNumber'
          },
          {
            'label': 'ДАТА ОТГРУЗКИ',
            'value': 'ShipmentDate'
          },
          {
            'label': 'БАЗА',
            'value': 'TerminalName'
          },
          {
            'label': 'ПЛОТНОСТЬ',
            'value': 'Density'
          },
          {
            'label': 'ФАКТИЧ, литр ВЕС литр',
            'value': 'AmountInLitre'
          },
          {
            'label': 'ТОННА ВЕС тонна',
            'value': 'AmountInTonne'
          },
          {
            'label': 'ЦЕНА СУМ РУз/тонна',
            'value': 'GrossPricePerTonne'
          },
          {
            'label': 'ЦЕНА  СУМ литр',
            'value': 'GrossPricePerLitre'
          },
          {
            'label': 'СТОИМОСТЬ без НДС и без АКЦИЗа',
            'value': 'NetTotal'
          },
          {
            'label': 'АКЦИЗ тонна',
            'value': 'Excise'
          },
          {
            'label': 'АКЦИЗ сумма',
            'value': 'TotalExcise'
          },
          {
            'label': 'Стоимость поставки',
            'value': 'TotalNoVAT'
          },
          {
            'label': 'СТАВКА',
            'value': 'VATRate'
          },
          {
            'label': 'НДС Сумма',
            'value': 'VAT'
          },
          {
            'label': 'СУММА НДС АКЦИЗ',
            'value': 'Total'
          },
          {
            'label': 'ОПЛАТА',
            'value': 'Total1'
          },
          {
            'label': 'СТАТУС',
            'value': 'Status'
          },
          {
            'label': 'СТАТУС АВТО',
            'value': 'WaybillStatus'
          }
        ]

        const settings = {
          sheetName: 'FirstSheet',
          fileName: 'MySpreadsheet'
        }

        xlsx(oderColumns, result.data, settings)
      } else {
        alert('За выбранный период не было найдено записей.')
      }

    }
  }
}

</script>

<style scoped>
.text-left {
  border-right: 2px solid gray;
}

.tbody {
  border-right: 2px solid gray;
}

tbody {
  text-align: center !important;
  font-weight: bold !important;
}

tbody:hover {
  background-color: transparent !important;
  cursor: pointer !important;
}

thead tr th {
  font-weight: bolder !important;
  text-shadow: 0 0 1px black !important;
  font-size: 14px !important;
  text-transform: uppercase !important;
  position: relative;
  text-align: center !important;
  padding: 0 100px !important;
}

thead {
  padding: 10px !important;
  outline: 3px solid black !important;
}

thead tr th :after {
  content: '';
  position: absolute;
  left: 50%;
  margin-left: 50% !important;
  top: 0;
  height: 1500px !important;
  border-left: 2px solid grey !important;
  z-index: 1;
}

thead tr th {
  opacity: 1;
}

.red-color {
  background-color: #ff0000 !important;
  color: #f7f7f7;
  opacity: 0.8;
}

.warning-color {
  background-color: #ffff00 !important;
  color: black !important;
  opacity: 0.9;
}

.success-color {
  background-color: #00b24f !important;
  color: #f7f7f7;

  opacity: 0.8;
}

</style>